import ThumbnailOrBubbleIcon from 'core/modules/atoms/ThumbnailOrBubbleIcon';
import PreviewContent from 'core/modules/components/general/PreviewContent';
import { isLessonItemContentType } from 'core/utils/lesson';
import { isTabOneTool } from 'core/utils/projection';
import { typeContentsIcons } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import BackButton from 'ui/atoms/BackButton/BackButton';
import Button from 'ui/atoms/Button/Button';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import DialogNotes from 'core/modules/components/dialogs/DialogNotes/DialogNotes';

const DialogProjectLessonItem = ({ open, onClose, item, onSend, t, currentTabProjecting, itemSelected, onOpenLink }) => {
  const [isShowedDialogNotes, setIsShowedDialogNotes] = useState(false);
  const [isShowedDialogLinkWarning, setIsShowedDialogLinkWarning] = useState(false);

  function onClickLink() {
    setIsShowedDialogLinkWarning(true);
    onOpenLink(item);
  }

  function onCloseLinkWarning() {
    setIsShowedDialogLinkWarning(false);
  }

  function renderDetail() {
    let text = '';
    if (isLessonItemContentType(item.type, 'task')) {
      text = <p className="dialog-project-lesson-item__content-detail">{t('lesson:X questions', { count: item.test_amount_questions })}</p>;
    }

    return text;
  }

  function renderTopButton() {
    return (
      <>
        {!isLessonItemContentType(item.type, 'link') && (isTabOneTool(currentTabProjecting) || itemSelected.guid !== item.guid) && (
          <Button text={t('Send')} onClick={() => onSend(item)} size="sm" leftIcon="online" />
        )}
        {isLessonItemContentType(item.type, 'link') && (isTabOneTool(currentTabProjecting) || itemSelected.guid !== item.guid) && (
          <Button text={t('Open link')} onClick={onClickLink} size="sm" leftIcon="external-link" />
        )}
        {!isTabOneTool(currentTabProjecting) && itemSelected.guid === item.guid && (
          <div className="dialog-project-lesson-item__projecting">
            <Icon name="online" color="success" />
            <span className="dialog-project-lesson-item__projecting-text">{t('Projecting')}...</span>{' '}
          </div>
        )}
      </>
    );
  }

  function onShowDialogNotes() {
    setIsShowedDialogNotes(true);
  }

  function onCloseDialogNotes() {
    setIsShowedDialogNotes(false);
  }

  return (
    <>
      <Dialog ariaLabel={item?.name ?? t('lesson:Content')} isCloseButtonHidden isOpen={open} className={'dialog-project-lesson-item'} onClose={onClose} size="all-screen">
        <div className="dialog-project-lesson-item__header">
          <BackButton onClick={onClose} />
          {item && renderTopButton()}
        </div>

        {item && (
          <div className="dialog-project-lesson-item__content">
            <div className="dialog-project-lesson-item__content-header">
              <Icon name={typeContentsIcons[item.type]} size="xl" color="grey-02" />
              <span className="dialog-project-lesson-item__content-name">{item.name}</span>
            </div>

            {renderDetail()}

            <TextHtml className="dialog-project-lesson-item__content-description" text={item.description} />

            {item.teacher_notes && (
              <div className="dialog-project-lesson-item__notes">
                <Button text={t('assigments:Teacher notes')} variant="info" size="sm" leftIcon="teacher" iconSize="xl" onClick={onShowDialogNotes} />
              </div>
            )}

            <PreviewContent
              {...item}
              contentUrl={item.content_url}
              contentDescription={isLessonItemContentType(item.type, 'pdf') ? 'PDF' : ''}
              previewImage={true}
              measureProgress={false}
            />
          </div>
        )}

        {isShowedDialogNotes && <DialogNotes open={isShowedDialogNotes} notes={item.teacher_notes} onClose={onCloseDialogNotes} />}
      </Dialog>
      {isShowedDialogLinkWarning && (
        <Dialog
          ariaLabel={t('The link has been opened in a new tab on your computer, return to the page to continue sharing content from the lesson')}
          isCloseButtonHidden
          isOpen={isShowedDialogLinkWarning}
          className={'dialog-project-lesson-item__link'}
          onClose={onCloseLinkWarning}
          size="all-screen"
        >
          <button type="button" className="dialog-project-lesson-item__arrow" aria-label={t('actions:Close')} onClick={onCloseLinkWarning}>
            <Icon className="dialog-project-lesson-item__up-icon" name={'chevron-down'} color="white" />
          </button>

          <ThumbnailOrBubbleIcon thumbnail={item.content_thumbnail} type={typeContentsIcons[item.content_type_guid]} />

          <p className="dialog-project-lesson-item__message">
            {t('The link has been opened in a new tab on your computer, return to the page to continue sharing content from the lesson')}
          </p>
        </Dialog>
      )}
    </>
  );
};

DialogProjectLessonItem.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  item: PropTypes.object,
  onSend: PropTypes.func,
  t: PropTypes.func,
  currentTabProjecting: PropTypes.string,
  itemSelected: PropTypes.object,
  onOpenLink: PropTypes.func,
};

export default withTranslation(['project', 'lesson', 'assigments'])(DialogProjectLessonItem);
